import { isEqual } from "lodash";
import React, { useMemo} from "react";
import { useSelector} from "react-redux";
import MdaeButton from "../../common_widgets/button/component";
import { IMdaeDataGridProps } from "../../common_widgets/data-grid";
import MdaeDataGrid from "../../common_widgets/data-grid/component";
import MdaeTextBox from "../../common_widgets/text-box/component";
import LinkedAuditItems from "../linked-audit-items";

import "./index.scss";

const ExtraFieldTab: React.FC<any> = (props) => {
  const completeCaseDetail = useSelector(
    (state: any) => state.caseDetailReducer.completeCaseDetail,
    isEqual
  );

  const valueCodesDataSource = useSelector(
    (state: any) => state.caseDetailReducer.completeCaseDetail.valueCodes,
    isEqual
  );

    const aliasBillDataFields = useSelector(
        (state: any) => state.caseDetailReducer.aliasBillDataFields,
        isEqual
    );
  const caseFieldsTabFlags = useSelector(
    (state) => state["caseFieldsReducer"].caseFieldsTabFlags,
    isEqual
  );
  const currentCptYear = new Date().getFullYear();

  const getHeight = (list) => {
    if (list != undefined) {
      if (list.length > 0) {
        return "auto";
      } else {
        return "50px";
      }
    } else {
      return "50px";
    }
  };

  const getCodeValuesDataGridOptions = () => {
    const codeValuesDataGridOption: IMdaeDataGridProps = {
      id: "pnlCodeValueList",
      mdaeColumnChooser: { isMdaeColumnChooserVisible: false },
      export: { enabled: false },
      headerFilter: {
        visible: false,
      },
      selection: { mode: "single" },
      dataSource: valueCodesDataSource,
      allowColumnResizing: true,
      allowColumnReordering: true,
      filterRow: {
        visible: false,
      },
      height: getHeight(valueCodesDataSource),
      noDataText: "",
      mdaeColumns: [
        {
          dataField: "caseId",
          visible: "false",
        },
        {
          caption: "Code",
          dataField: "codeDesc",
          cellRender: (cellData) => {
            return (
              <div>
                {cellData.data.codeValue + " - " + cellData.data.codeDesc}
              </div>
            );
          },
          width: "60%",
        },
        {
          caption: "Amount",
          dataField: "codeAmt",
          alignment: "right",
          cellRender: (cellData) => {
            return <div>{cellData.data.codeAmt}</div>;
          },
          width: "40%",
        },
      ],
      pager: {
        showInfo: false,
      },
    };
    return codeValuesDataGridOption;
  };

  const codeValuesDataGridOptions = useMemo(() => {
    return getCodeValuesDataGridOptions();
  }, []);

  return (
    <>
      {" "}
      <LinkedAuditItems></LinkedAuditItems>
      <div className={"case-detail-extra-field-container"}>
        <div>
          <div className={"second-row-container"}>
            <div className={"first-container"}>
              <div>
                <div>
                  <MdaeTextBox
                    id={"txtCoder"}
                    value={completeCaseDetail.coder}
                    mdaeTextBoxTitle={"Coder"}
                    disabled={true}
                  ></MdaeTextBox>
                </div>
                <div className={"widget-separation-margin-top"}>
                  <MdaeTextBox
                    id={"txtReferringProvider"}
                    value={completeCaseDetail.referringProvider}
                    mdaeTextBoxTitle={"Referring Provider"}
                    disabled={true}
                  ></MdaeTextBox>
                </div>
                <div className={"widget-separation-margin-top"}>
                  {!caseFieldsTabFlags.isProfessional && (
                    <MdaeTextBox
                      id={"txtOperatingProvider"}
                      value={completeCaseDetail.operatingProvider}
                      mdaeTextBoxTitle={"Operating Provider"}
                      disabled={true}
                    ></MdaeTextBox>
                  )}
                </div>
                <div className={"widget-separation-margin-top"}>
                  {!caseFieldsTabFlags.isProfessional && (
                    <MdaeTextBox
                      id={"txtBillType"}
                      value={completeCaseDetail.billClassificationCode}
                      mdaeTextBoxTitle={"Bill Type"}
                      disabled={true}
                    ></MdaeTextBox>
                  )}
                </div>
                <div className={"widget-separation-margin-top"}>
                  <div className={"mdae-data-field-label"}>Value Codes</div>
                  <div>
                    <MdaeDataGrid {...codeValuesDataGridOptions}></MdaeDataGrid>
                  </div>
                </div>
              </div>
            </div>
            <div className={"second-container"}>
              <div>
                <div>
                  <MdaeTextBox
                    id={"ddlInvestDevice"}
                    value={completeCaseDetail.investDeviceExmptNo}
                    mdaeTextBoxTitle={"Invest Device"}
                    disabled={true}
                  ></MdaeTextBox>
                </div>
                <div className={"widget-separation-margin-top"}>
                  <MdaeTextBox
                    id={"txtClinicalTrial"}
                    value={completeCaseDetail.clinicalTrialIdentifier}
                    mdaeTextBoxTitle={"Clinical Trial#"}
                    disabled={true}
                  ></MdaeTextBox>
                </div>
                <div className={"widget-separation-margin-top"}>
                  <MdaeTextBox
                    id={"txtPriorAuth"}
                    value={completeCaseDetail.priorAuthorizationNo}
                    mdaeTextBoxTitle={"Prior Auth#"}
                    disabled={true}
                  ></MdaeTextBox>
                </div>
                <div className={"widget-separation-margin-top"}>
                  <MdaeTextBox
                    id={"txtReferral"}
                    value={completeCaseDetail.referralNo}
                    mdaeTextBoxTitle={"Referral"}
                    disabled={true}
                  ></MdaeTextBox>
                </div>
                <div className={"widget-separation-margin-top"}>
                  <MdaeTextBox
                    id={"txtLocation"}
                    value={completeCaseDetail.serviceFacilityLocation}
                    mdaeTextBoxTitle={"Location"}
                    disabled={true}
                  ></MdaeTextBox>
                </div>
              </div>
            </div>
            <div className={"third-container"}>
              <div>
                <div>
                  <div className={"personal-information-container"}>
                    <div className={"gender-container"}>
                      <MdaeTextBox
                        id={"txtGender"}
                        value={completeCaseDetail.gender}
                        mdaeTextBoxTitle={"Sex"}
                        disabled={true}
                      ></MdaeTextBox>
                    </div>
                    <div className={"dob-container"}>
                      <MdaeTextBox
                        id={"txtDob"}
                        value={completeCaseDetail.dob}
                        mdaeTextBoxTitle={"DOB"}
                        disabled={true}
                      ></MdaeTextBox>
                    </div>
                    <div className={"age-container"}>
                      <div className={"mdae-data-field-label"}>Age</div>
                      <div className={"common-top-margin"}>
                        {completeCaseDetail.ageAtEncounter}
                      </div>
                    </div>
                  </div>
                  <div className={"widget-separation-margin-top"}>
                    <div className={"zip-subscriber-container"}>
                      <div className={"zip-container"}>
                        <div className={"mdae-data-field-label"}>Zip</div>
                        <div className={"common-top-margin"}>
                          {completeCaseDetail.zipCode}
                        </div>
                      </div>
                      <div className={"subscriber-container"}>
                        <div className={"mdae-data-field-label"}>
                          Subscriber
                        </div>
                        <div className={"common-top-margin"}>
                          {completeCaseDetail.subscriberId}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={"widget-separation-margin-top"}>
                    <div className={"subscriber-name-container"}>
                      <div className={"mdae-data-field-label"}>
                        Subscriber Name
                      </div>
                      <div className={"common-top-margin"}>
                        {completeCaseDetail.subscriberName}
                      </div>
                    </div>
                  </div>
                  <div className={"widget-separation-margin-top"}>
                    <div className={"caseid-container"}>
                      <div className={"mdae-data-field-label"}>Case Id</div>
                      <div className={"common-top-margin"}>
                        {completeCaseDetail.caseId}
                      </div>
                    </div>
                  </div>
                  <div className={"widget-separation-margin-top"}>
                    <div className={"caseid-container"}>
                      <div className={"mdae-data-field-label"}>
                        Additional MRN
                      </div>
                      <div className={"common-top-margin"}>
                        {completeCaseDetail.patientAlternateMRN}
                      </div>
                    </div>
                  </div>
                  <div className={"widget-separation-margin-top"}>
                    <div className={"caseid-container"}>
                      <div className={"mdae-data-field-label"}>
                        Additional Account Number
                      </div>
                      <div className={"common-top-margin"}>
                        {completeCaseDetail.addPatientAcctNo}
                      </div>
                    </div>
                  </div>
                  <div className={"widget-separation-margin-top"}>
                    <div className={"caseid-container"}>
                      <div className={"mdae-data-field-label"}>CDI</div>
                      <div className={"common-top-margin"}>
                        {completeCaseDetail.cdiName}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={"fourth-container"}>
              <div>
                <div>
                  <div className={"billdate-caseid-container"}>
                    <div className={"billdate-container"}>
                      <div className={"mdae-data-field-label"}>Bill Date</div>
                      <div className={"common-top-margin"}>
                        {completeCaseDetail.billDate}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"widget-separation-margin-top"}>
                  <div className={"total-claim-charges-container"}>
                    <div className={"mdae-data-field-label"}>File Name</div>
                    <div className={"common-top-margin"}>
                      {completeCaseDetail.fileName}
                    </div>
                  </div>
                </div>
                <div className={"widget-separation-margin-top"}>
                  <div className={"total-claim-charges-container"}>
                    <div className={"mdae-data-field-label"}>Data Loaded</div>
                    <div className={"common-top-margin"}>
                      {completeCaseDetail.fileLoadDate}
                    </div>
                  </div>
                </div>
                <div className={"widget-separation-margin-top"}>
                  <div className={"total-claim-charges-container"}>
                    <div className={"mdae-data-field-label"} style={{ overflowWrap: 'break-word' }}>
                      {aliasBillDataFields?.caseBillData1AliasName ??
                        "Bill Data 1"}
                    </div>
                    <div className={"common-top-margin"} style={{ overflowWrap: 'break-word' }}>
                      {completeCaseDetail.billData1Name
                        ? `${completeCaseDetail.billData1ID}, ${completeCaseDetail.billData1Name}`
                        : ""}
                    </div>
                  </div>
                </div>
                <div className={"widget-separation-margin-top"}>
                  <div className={"total-claim-charges-container"}>
                    <div className={"mdae-data-field-label"} style={{ overflowWrap: 'break-word' }}>
                      {aliasBillDataFields?.caseBillData2AliasName ??
                        "Bill Data 2"}
                    </div>
                    <div className={"common-top-margin"} style={{ overflowWrap: 'break-word' }}>
                      {completeCaseDetail.billData2Name
                        ? `${completeCaseDetail.billData2ID}, ${completeCaseDetail.billData2Name}`
                        : ""}
                    </div>
                  </div>
                </div>
                <div className={"widget-separation-margin-top"}>
                  <div className={"total-claim-charges-container"}>
                    <div className={"mdae-data-field-label"} style={{ overflowWrap: 'break-word' }}>
                      {aliasBillDataFields?.caseBillData3AliasName ??
                        "Bill Data 3"}
                    </div>
                    <div className={"common-top-margin"} style={{ overflowWrap: 'break-word' }}>
                      {completeCaseDetail.billData3Name
                        ? `${completeCaseDetail.billData3ID}, ${completeCaseDetail.billData3Name}`
                        : ""}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={"third-row-container"}>
          <div className="fa-inline-line-height">
            <span className="cpt-inline-font-style">
              CPT &reg; only &copy; {currentCptYear} American Medical
              Association. All Rights Reserved.
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExtraFieldTab;
